import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BatchRequestService {

  constructor(private http: HttpClient) { }

  getMonitoringData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build URL with query parameters (GET request like original AngularJS)
    const url = `${baseUrl}/getRequestData?request_id=${params.request_id}&ist_tkn=${params.ist_tkn}`;
    
    // For GET requests, we use standard headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.get<any>(url, httpOptions);
  }
}
